// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file inventory/v1/artifact_service.proto (package inventory.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Artifact } from "../../artifacts/v1/model_pb";
import { file_artifacts_v1_model } from "../../artifacts/v1/model_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file inventory/v1/artifact_service.proto.
 */
export const file_inventory_v1_artifact_service: GenFile = /*@__PURE__*/
  fileDesc("CiNpbnZlbnRvcnkvdjEvYXJ0aWZhY3Rfc2VydmljZS5wcm90bxIMaW52ZW50b3J5LnYxIkQKGkxpc3RDb21wYW55QXJ0aWZhY3RSZXF1ZXN0EhIKCmNvbXBhbnlfaWQYASABKAkSEgoKY291bnRfb25seRgCIAEoCCJQChlMaXN0Q29tcGFueUFydGlmYWN0Q291bnRzEhQKDG5vbl9hcmNoaXZlZBgBIAEoBRIQCghhcmNoaXZlZBgCIAEoBRILCgN3ZWIYAyABKAUihwEKG0xpc3RDb21wYW55QXJ0aWZhY3RSZXNwb25zZRIpCglhcnRpZmFjdHMYASADKAsyFi5hcnRpZmFjdHMudjEuQXJ0aWZhY3QSPQoMdG90YWxfY291bnRzGAIgASgLMicuaW52ZW50b3J5LnYxLkxpc3RDb21wYW55QXJ0aWZhY3RDb3VudHMiTAofTGlzdFVzZXJTb3VyY2VkQXJ0aWZhY3RSZXNwb25zZRIpCglhcnRpZmFjdHMYASADKAsyFi5hcnRpZmFjdHMudjEuQXJ0aWZhY3QihAEKHkxpc3RVc2VyU291cmNlZEFydGlmYWN0UmVxdWVzdBIXCgpjb21wYW55X2lkGAEgASgJSACIAQESIQoUYXJ0aWZhY3Rfc3ViY2F0ZWdvcnkYAiABKAlIAYgBAUINCgtfY29tcGFueV9pZEIXChVfYXJ0aWZhY3Rfc3ViY2F0ZWdvcnky/wEKD0FydGlmYWN0U2VydmljZRJ7ChdMaXN0VXNlclNvdXJjZWRBcnRpZmFjdBIsLmludmVudG9yeS52MS5MaXN0VXNlclNvdXJjZWRBcnRpZmFjdFJlcXVlc3QaLS5pbnZlbnRvcnkudjEuTGlzdFVzZXJTb3VyY2VkQXJ0aWZhY3RSZXNwb25zZSIDkAIBEm8KE0xpc3RDb21wYW55QXJ0aWZhY3QSKC5pbnZlbnRvcnkudjEuTGlzdENvbXBhbnlBcnRpZmFjdFJlcXVlc3QaKS5pbnZlbnRvcnkudjEuTGlzdENvbXBhbnlBcnRpZmFjdFJlc3BvbnNlIgOQAgFCvAEKEGNvbS5pbnZlbnRvcnkudjFCFEFydGlmYWN0U2VydmljZVByb3RvUAFaQWdpdGh1Yi5jb20vbGVtYS5haS9sZW1tYXRhL2FwaS9wcm90by9nZW4vaW52ZW50b3J5L3YxO2ludmVudG9yeXYxogIDSVhYqgIMSW52ZW50b3J5LlYxygIMSW52ZW50b3J5XFYx4gIYSW52ZW50b3J5XFYxXEdQQk1ldGFkYXRh6gINSW52ZW50b3J5OjpWMWIGcHJvdG8z", [file_artifacts_v1_model]);

/**
 * @generated from message inventory.v1.ListCompanyArtifactRequest
 */
export type ListCompanyArtifactRequest = Message<"inventory.v1.ListCompanyArtifactRequest"> & {
  /**
   * @generated from field: string company_id = 1;
   */
  companyId: string;

  /**
   * Return only total_counts, skipping the artifact rows. For badges, not tables.
   *
   * @generated from field: bool count_only = 2;
   */
  countOnly: boolean;
};

/**
 * Describes the message inventory.v1.ListCompanyArtifactRequest.
 * Use `create(ListCompanyArtifactRequestSchema)` to create a new message.
 */
export const ListCompanyArtifactRequestSchema: GenMessage<ListCompanyArtifactRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_artifact_service, 0);

/**
 * @generated from message inventory.v1.ListCompanyArtifactCounts
 */
export type ListCompanyArtifactCounts = Message<"inventory.v1.ListCompanyArtifactCounts"> & {
  /**
   * What tab badges show.
   *
   * @generated from field: int32 non_archived = 1;
   */
  nonArchived: number;

  /**
   * @generated from field: int32 archived = 2;
   */
  archived: number;

  /**
   * Non-archived artifacts sourced from the public web (DOCUMENT_SOURCE_WEB).
   *
   * @generated from field: int32 web = 3;
   */
  web: number;
};

/**
 * Describes the message inventory.v1.ListCompanyArtifactCounts.
 * Use `create(ListCompanyArtifactCountsSchema)` to create a new message.
 */
export const ListCompanyArtifactCountsSchema: GenMessage<ListCompanyArtifactCounts> = /*@__PURE__*/
  messageDesc(file_inventory_v1_artifact_service, 1);

/**
 * @generated from message inventory.v1.ListCompanyArtifactResponse
 */
export type ListCompanyArtifactResponse = Message<"inventory.v1.ListCompanyArtifactResponse"> & {
  /**
   * @generated from field: repeated artifacts.v1.Artifact artifacts = 1;
   */
  artifacts: Artifact[];

  /**
   * Always populated, including when count_only.
   *
   * @generated from field: inventory.v1.ListCompanyArtifactCounts total_counts = 2;
   */
  totalCounts?: ListCompanyArtifactCounts;
};

/**
 * Describes the message inventory.v1.ListCompanyArtifactResponse.
 * Use `create(ListCompanyArtifactResponseSchema)` to create a new message.
 */
export const ListCompanyArtifactResponseSchema: GenMessage<ListCompanyArtifactResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_artifact_service, 2);

/**
 * @generated from message inventory.v1.ListUserSourcedArtifactResponse
 */
export type ListUserSourcedArtifactResponse = Message<"inventory.v1.ListUserSourcedArtifactResponse"> & {
  /**
   * @generated from field: repeated artifacts.v1.Artifact artifacts = 1;
   */
  artifacts: Artifact[];
};

/**
 * Describes the message inventory.v1.ListUserSourcedArtifactResponse.
 * Use `create(ListUserSourcedArtifactResponseSchema)` to create a new message.
 */
export const ListUserSourcedArtifactResponseSchema: GenMessage<ListUserSourcedArtifactResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_artifact_service, 3);

/**
 * @generated from message inventory.v1.ListUserSourcedArtifactRequest
 */
export type ListUserSourcedArtifactRequest = Message<"inventory.v1.ListUserSourcedArtifactRequest"> & {
  /**
   * @generated from field: optional string company_id = 1;
   */
  companyId?: string;

  /**
   * @generated from field: optional string artifact_subcategory = 2;
   */
  artifactSubcategory?: string;
};

/**
 * Describes the message inventory.v1.ListUserSourcedArtifactRequest.
 * Use `create(ListUserSourcedArtifactRequestSchema)` to create a new message.
 */
export const ListUserSourcedArtifactRequestSchema: GenMessage<ListUserSourcedArtifactRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_artifact_service, 4);

/**
 * @generated from service inventory.v1.ArtifactService
 */
export const ArtifactService: GenService<{
  /**
   * @generated from rpc inventory.v1.ArtifactService.ListUserSourcedArtifact
   */
  listUserSourcedArtifact: {
    methodKind: "unary";
    input: typeof ListUserSourcedArtifactRequestSchema;
    output: typeof ListUserSourcedArtifactResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.ArtifactService.ListCompanyArtifact
   */
  listCompanyArtifact: {
    methodKind: "unary";
    input: typeof ListCompanyArtifactRequestSchema;
    output: typeof ListCompanyArtifactResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_inventory_v1_artifact_service, 0);

